import React from 'react';

import {Markdown} from '../utils/md';
import {ruleParagraph} from '../render-helpers';
import type {RuleExcerpt} from '../../generated/types';

type Props = {
	excerpts: Pick<RuleExcerpt, 'ruleId' | 'title' | 'text'>[];
	/** заголовок второго уровня над каждым пояснением (типы существ на странице чудовища); по умолчанию — врезной заголовок */
	headings?: boolean;
};

/** пояснения из статей правил: свойства оружия, категории брони, яды, типы существ; понятие в тексте — ссылка на статью */
export const RuleExcerpts: React.FC<Props> = ({excerpts, headings}) => (
	<>
		{excerpts.map(({ruleId, title, text}) => {
			const key = `${ruleId}:${title}`;
			if (headings)
				return (
					<React.Fragment key={key}>
						<h2>{title}</h2>
						<Markdown text={ruleParagraph(ruleId, title, text)} />
					</React.Fragment>
				);
			if (text.startsWith('[')) return <Markdown key={key} text={`### ${title}\n\n${text}`} />;
			return <Markdown key={key} text={`*_${title}._* ${ruleParagraph(ruleId, title, text)}`} />;
		})}
	</>
);
